type ColumnSpec = string | { name: string; dtype?: string }

export function normalizeColumns(columns: unknown): string[] {
  if (Array.isArray(columns)) {
    return (columns as ColumnSpec[]).map((c) =>
      typeof c === 'string' ? c : c?.name ?? '',
    )
  }
  return []
}

export function normalizeRows(rows: unknown, headers: string[]): unknown[][] {
  if (!Array.isArray(rows)) return []
  if (rows.length === 0) return []
  const first = rows[0]
  if (Array.isArray(first)) {
    return (rows as unknown[][]).map((r) => r.slice())
  }
  if (first && typeof first === 'object') {
    return (rows as Record<string, unknown>[]).map((row) =>
      headers.map((h) => row[h] ?? null),
    )
  }
  return []
}
